export default "__VITE_ASSET__Dw5R2MWL__"